import { combineReducers } from 'redux';
import newChatReducer from '../../features/avaChatbot/data/newChat';
import sendMessageReducer from '../../features/avaChatbot/data/sendMessage';



const rootReducer = combineReducers({
   newChat: newChatReducer,
   sendMessageSlice: sendMessageReducer
});

export default rootReducer;
